var BuildingMaxLevel;
(function (BuildingMaxLevel) {
    BuildingMaxLevel[BuildingMaxLevel["ONE_OFF"] = 14] = "ONE_OFF";
    BuildingMaxLevel[BuildingMaxLevel["WORKSHOP_1"] = 5] = "WORKSHOP_1";
    BuildingMaxLevel[BuildingMaxLevel["WORKSHOP_2"] = 6] = "WORKSHOP_2";
    BuildingMaxLevel[BuildingMaxLevel["WORKSHOP_3"] = 2] = "WORKSHOP_3";
    BuildingMaxLevel[BuildingMaxLevel["THREE_OFF"] = 42] = "THREE_OFF";
})(BuildingMaxLevel || (BuildingMaxLevel = {}));
export default BuildingMaxLevel;
